<template>
    <div class="enrollment">
        <div class="information">
            <div class="columns">
                <div class="column is-narrow is-hidden-touch">
                    <i class="fad fa-chalkboard-teacher has-text-primary fa-2x"></i>
                </div>
                <div class="column">
                    <div class="columns is-block-tablet is-flex-widescreen">
                        <div class="column">
                            <div class="has-text-weight-bold">
                                <i class="fad fa-chalkboard-teacher has-text-primary is-hidden-desktop mr-2"></i>
                                {{ enrollment.courses.title }}
                            </div>
                            <div class="enrollment-meta mb-3">
                                {{ enrollment.courses.organizations.title }}
                            </div>
                            <div v-if="!enrollment.completed_at">
                                <!-- Hours Progress (if max_hours is set) -->
                                <div v-if="enrollment.max_hours > 0" class="mb-3">
                                    <b-progress
                                        type="is-info"
                                        size=""
                                        :value="Math.min((enrollment.total_logged_hours / enrollment.max_hours) * 100, 100)"
                                        class="enroll-progress mr-6"
                                    />
                                    <div class="enrollment-meta has-text-grey">
                                        {{ enrollment.total_logged_hours }} of {{ enrollment.max_hours }} hours logged
                                        ({{ Math.min(((enrollment.total_logged_hours / enrollment.max_hours) * 100), 100).toFixed(0) }}%)
                                    </div>
                                </div>
                                <!-- Lessons Progress -->
                                <b-progress type="is-primary" size="" :value="(enrollment.lessons_completed/enrollment.lessons)*100" class="enroll-progress mr-6"/>
                                <div class="enrollment-meta has-text-grey">{{ enrollment.lessons_completed }} of {{ enrollment.lessons }} lessons completed ({{ ((enrollment.lessons_completed / enrollment.lessons) * 100).toFixed(0) }}%).</div>
                            </div>
                            <div v-else>
                                <div class="enrollment-meta has-text-grey"><i class="far fa-check-circle mr-2 has-text-success"></i>Completed on {{ enrollment.completed_at | moment('MMMM Do, YYYY') }}.</div>
                            </div>
                        </div>
                        <div class="column has-text-right is-narrow">
                            <div v-if="!enrollment.completed_at">
                                <router-link :to="'/course/' + enrollment.id">
                                    <b-button type="is-primary" size="" expanded><i class="fas fa-pencil mr-2"></i>Open Course</b-button>
                                </router-link>
                            </div>
                            <div v-else>
                                <template v-if="enrollment.courses.new_course">
                                    <router-link :to="'/course/' + enrollment.id">
                                        <b-button type="is-primary" outlined size="" expanded class="mb-2"><i class="fas fa-eye mr-2"></i>Review Course</b-button>
                                    </router-link>

                                    <router-link :to="{name: 'course-applications', params: {enrollmentId: enrollment.id}}">
                                        <b-button type="is-primary" size="" expanded><i class="fas fa-file-certificate mr-2"></i>Certificates</b-button>
                                    </router-link>
                                </template>

                                <!--                        <router-link v-else :to="'/legacy/' + enrollment.id">-->
                                <!--                            <b-button type="is-primary" outlined size="" expanded class="mb-2"><i class="fas fa-eye mr-2"></i>Review Course</b-button>-->
                                <!--                        </router-link>-->

                            </div>
                        </div>
                    </div>

                    <router-link :to="{name: 'course-applications', params: {enrollmentId: enrollment.id}}"  v-if="enrollment.completed_at && enrollment.isIncompleteApps">
                        <b-message type="is-warning">
                            <div class="columns is-gapless">
                                <div class="column is-narrow"><i class="fas fa-exclamation-triangle fa-fw mr-3 has-text-warning"></i></div>
                                <div class="column">
                                    <div class="is-size-6 has-text-weight-bold">Incomplete Applications or Forms</div>
                                    <div class="is-size-7-mt-3">You have incomplete applications or forms that you may wish to complete. Review <i class="fad ml-1 fa-file-certificate mr-2"></i>Certifications & Forms.</div>
                                </div>
                            </div>
                        </b-message>
                    </router-link>
                </div>
            </div>


        </div>
        <div class="details">

        </div>

    </div>
</template>

<script>
    export default {
        name: "Enrollment",
        props: {
            enrollment: {
                required: true
            }
        },

    };
</script>

<style lang="scss" scoped>
    .enrollment {
        background-color: white;
        border-radius: 4px;
        box-shadow: 5px 5px 30px 0 rgba(0, 0, 0, 0.4);

        .information {
            padding: 1.5rem 1.5rem 1.5rem;
        }

        .enrollment-meta {
            font-size: 0.9rem;
        }
    }
</style>

<style lang="scss">
    .enroll-progress {
        margin-bottom: 0.2rem !important;

        .progress {
            height: 0.25rem !important;
        }
    }
</style>
